import axiosInstance from './AxiosInstance';

class MohaService {

    constructor() {
        this.endpoint = "/api/moha"
    }

    async create_batch(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/batches`, data);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }

    async get_batch_list(pageIndex = 1, pageSize = 1000) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/batches?PageIndex=${pageIndex}&PageSize=${pageSize}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }
    async get_batch_ids_list(MohaBatchID,pageIndex = 1, pageSize = 1000) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/batches/${MohaBatchID}/records?MohaBatchID=${MohaBatchID}&PageIndex=${pageIndex}&PageSize=${pageSize}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }
    async get_batch_file(batchID) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/batches/${batchID}/file`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return {success:false,message:'fail to proccess request'}
        }
    }
    async upload_batch_file(batchID, fileData) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/batches/${batchID}/file`, {
                "mohaBatchID": batchID,
                "fileData": fileData
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }
}
const mohaService = new MohaService();

export { mohaService };